import * as React from "react";
import type { SVGProps } from "react";
const SvgBuiltInWardrobesIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      d="M14 1c-1.43 0-2.6 1.17-2.6 2.6 0 1.11.687 1.792 1.235 2.226.274.218.522.402.666.553.144.15.179.223.179.341v.764c-.47.28-9.529 5.691-10.156 6.077-.559.344-1.097.648-1.544 1.073S1 15.647 1 16.372c0 .707.309 1.329.796 1.723s1.132.585 1.804.585h1.04v-1.04H3.6c-.475 0-.871-.142-1.138-.358-.266-.215-.422-.489-.422-.91 0-.444.144-.694.455-.99.31-.297.808-.592 1.381-.943.52-.32 9.65-5.793 10.124-6.078.473.285 9.604 5.759 10.124 6.078.573.351 1.07.646 1.381.942.31.297.455.547.455.991 0 .421-.156.695-.422.91-.267.216-.663.358-1.138.358h-1.04v1.04h1.04c.674 0 1.316-.19 1.804-.585A2.2 2.2 0 0 0 27 16.372c0-.725-.333-1.314-.78-1.738-.447-.425-.985-.73-1.544-1.073-.627-.386-9.687-5.797-10.156-6.077V6.72c0-.44-.226-.8-.471-1.056-.246-.256-.518-.455-.764-.65-.492-.39-.845-.699-.845-1.414 0-.867.693-1.56 1.56-1.56s1.56.693 1.56 1.56a.52.52 0 0 0 .258.457.53.53 0 0 0 .524 0A.52.52 0 0 0 16.6 3.6C16.6 2.17 15.43 1 14 1M7.24 15.04c-.855 0-1.56.705-1.56 1.56v8.84c0 .855.705 1.56 1.56 1.56h13.52c.855 0 1.56-.705 1.56-1.56V16.6c0-.855-.705-1.56-1.56-1.56zm0 1.04h13.52a.51.51 0 0 1 .52.52v8.84a.51.51 0 0 1-.52.52H7.24a.51.51 0 0 1-.52-.52V16.6a.51.51 0 0 1 .52-.52"
    />
  </svg>
);
export default SvgBuiltInWardrobesIcon;
